export default __webpack_public_path__ + "static/media/p15.ee95421d.jpg";